/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoicePaymentConfig } from './InvoicePaymentConfig';
import type { OnlinePaymentConfig } from './OnlinePaymentConfig';
export type TogglePaymentTypePayload = {
    paymentType: TogglePaymentTypePayload.paymentType;
    enabled: boolean;
    invoiceConfig?: InvoicePaymentConfig;
    onlineConfig?: OnlinePaymentConfig;
    returnPath?: string;
};
export namespace TogglePaymentTypePayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

